import { stringify, parse } from "@insightfulscience/shared-utils/parsers/json";
import type { CookieAttributes } from "js-cookie";
import type { ItemStorage, IStorage } from "@interfaces";

export const ItemStorageFactory = <T>(
	storage: IStorage,
	keyName: string,
	defOptions: CookieAttributes = {},
	serialize: (data: T) => string = stringify,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	deserialize: (data: string) => T = parse as any,
): ItemStorage<T> => ({
	write: (value: T, options?: CookieAttributes) =>
		storage.write(keyName, serialize(value), { ...defOptions, ...options }),
	read: () => {
		const stored = storage.read(keyName);
		return typeof stored === "string" ? deserialize(stored) : undefined;
	},
	clear: () => storage.remove(keyName),
});
